import { Redirect } from "wouter"

const RequireLoggedIn = props => {
  if (!props.isLogged) {
    return <Redirect to={"/dashboard/login"} />
  }
  return <>{props.children}</>
}

export default RequireLoggedIn
